<template>
	<div class="app-container">
		<div class="filter-container">
			<el-form ref="queryForm" inline :model="listQuery" @submit.native.prevent>
				<el-form-item prop="nickname">
					<el-input v-model="listQuery.nickname" placeholder="用户昵称" clearable @keyup.enter.native="SearchData" />
				</el-form-item>
				<el-form-item prop="phone">
					<el-input v-model="listQuery.phone" placeholder="手机号" clearable @keyup.enter.native="SearchData" />
				</el-form-item>
				<el-form-item prop="status">
					<el-select v-model="listQuery.status" placeholder="审批状态" clearable @keyup.enter.native="SearchData">
						<el-option label="待审批" value="pending" />
						<el-option label="已驳回" :value="3" />
						<el-option label="已完成" :value="4" />
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" icon="el-icon-search" @click="SearchData">搜索</el-button>
					<el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
				</el-form-item>
			</el-form>
		</div>

		<el-table v-loading="listLoading" :data="list" border fit highlight-current-row style="width: 100%">
			<el-table-column type="index" label="序号" width="55" :index="indexMethod" align="center" />
			<el-table-column align="center" prop="avatar" label="头像" width="88">
				<template slot-scope="{ row }">
					<el-avatar :size="40" :src="row.avatar" @error="true">
						<img :src="base_url + 'uploads/default_avatar.png'" alt="">
					</el-avatar>
				</template>
			</el-table-column>
			<el-table-column align="center" prop="nickname" label="昵称" min-width="100" />
			<el-table-column align="center" prop="phone" label="手机号" width="120" />
			<el-table-column align="center" label="调整类型" width="88">
				<template slot-scope="{ row }">
					<el-tag :type="row.adjust_type == 1 ? 'success' : 'danger'" size="small">
						{{ row.adjust_type == 1 ? '增加' : '减少' }}
					</el-tag>
				</template>
			</el-table-column>
			<el-table-column align="center" prop="money" label="金额" width="100" />
			<el-table-column align="center" label="调整原因" min-width="110">
				<template slot-scope="{ row }">{{ reasonLabel(row.reason) }}</template>
			</el-table-column>
			<el-table-column align="center" label="状态" width="110">
				<template slot-scope="{ row }">{{ statusLabel(row.status) }}</template>
			</el-table-column>
			<el-table-column align="center" prop="creator_name" label="申请人" width="100" />
			<el-table-column align="center" label="申请时间" width="160">
				<template slot-scope="{ row }">{{ row.create_time | parseTime }}</template>
			</el-table-column>
			<el-table-column align="center" label="操作" width="340" fixed="right">
				<template slot-scope="{ row }">
					<div class="op-rows">
						<el-button v-auth="'UserMoneyAdjustList.detail'" type="primary" plain size="mini" icon="el-icon-view"
							@click="openDetail(row)">详情</el-button>
						<el-button v-if="row.status === 3" v-auth="'UserMoneyAdjustList.edit'" type="primary" plain size="mini"
							icon="el-icon-edit" @click="openEdit(row)">编辑</el-button>
						<el-button v-if="row.status !== 4" v-auth="'UserMoneyAdjustList.delete'" type="danger" plain size="mini"
							icon="el-icon-delete" @click="handleDelete(row)">删除</el-button>
						<el-button v-if="canApprove(row)" v-auth="'UserMoneyAdjustList.approve'" type="warning" plain size="mini"
							icon="el-icon-s-check" @click="openApprove(row)">审批</el-button>
					</div>
				</template>
			</el-table-column>
		</el-table>

		<pagination v-show="total > 0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit"
			@pagination="loadData" />

		<!-- 详情 -->
		<el-dialog custom-class="money-adjust-detail-dialog" title="余额调整详情" :visible.sync="detailVisible" width="720px"
			top="10vh" @closed="detailClosed">
			<div v-loading="detailLoading" class="detail-body">
				<template v-if="detailData && !detailLoading">
					<div class="detail-user-card">
						<el-avatar :size="56" :src="detailAvatarSrc" @error="true">
							<img :src="base_url + 'uploads/default_avatar.png'" alt="">
						</el-avatar>
						<div class="detail-user-meta">
							<div class="detail-user-name">{{ detailData.nickname || '—' }}</div>
							<div class="detail-user-sub">{{ detailData.phone || '—' }}</div>
						</div>
						<div class="detail-status-pill">
							<el-tag :type="statusTagType(detailData.status)" effect="dark" size="medium">
								{{ statusLabel(detailData.status) }}
							</el-tag>
						</div>
					</div>

					<div class="detail-section-title">调整信息</div>
					<el-descriptions :column="2" border size="small" class="detail-desc">
						<el-descriptions-item label="调整类型">
							<el-tag :type="detailData.adjust_type == 1 ? 'success' : 'danger'" size="small">
								{{ detailData.adjust_type == 1 ? '增加' : '减少' }}
							</el-tag>
						</el-descriptions-item>
						<el-descriptions-item label="金额">
							<span class="detail-money">{{ formatMoney(detailData.money) }}</span>
						</el-descriptions-item>
						<el-descriptions-item label="调整原因" :span="2">
							{{ reasonLabel(detailData.reason) }}
							<span v-if="detailData.reason === 'other' && detailData.reason_text" class="detail-reason-extra">
								（{{ detailData.reason_text }}）
							</span>
						</el-descriptions-item>
						<el-descriptions-item v-if="detailData.remark" label="备注" :span="2">
							{{ detailData.remark }}
						</el-descriptions-item>
						<el-descriptions-item v-if="attachmentUrls.length" label="凭证" :span="2">
							<div class="detail-attachments">
								<el-image v-for="(u, idx) in attachmentUrls" :key="idx" class="detail-att-img" fit="cover"
									:src="u + '!size=150X150'" :preview-src-list="attachmentUrls" />
							</div>
						</el-descriptions-item>
					</el-descriptions>

					<div class="detail-section-title">申请与审批</div>
					<el-descriptions :column="2" border size="small" class="detail-desc">
						<el-descriptions-item label="申请人">{{ detailData.creator_name || '—' }}</el-descriptions-item>
						<el-descriptions-item label="申请时间">{{ detailData.create_time | parseTime }}</el-descriptions-item>
						<el-descriptions-item label="一级审批人">
							{{ detailData.level1_admin_name || (detailData.level1_admin_id ? 'ID ' + detailData.level1_admin_id : '—') }}
						</el-descriptions-item>
						<el-descriptions-item label="二级审批人">
							{{ detailData.level2_admin_name || (detailData.level2_admin_id ? 'ID ' + detailData.level2_admin_id : '—') }}
						</el-descriptions-item>
					</el-descriptions>

					<div class="detail-section-title">审批进度</div>
					<el-timeline class="detail-timeline">
						<el-timeline-item :timestamp="formatTs(detailData.create_time)" placement="top" type="primary">
							<div class="tl-title">提交申请</div>
							<div class="tl-sub">{{ detailData.creator_name || '—' }}</div>
						</el-timeline-item>
						<el-timeline-item v-if="detailData.level1_time || detailData.level1_result"
							:timestamp="formatTs(detailData.level1_time)" placement="top"
							:type="timelineType(detailData.level1_result)">
							<div class="tl-title">一级审批{{ approveResultSuffix(detailData.level1_result) }}</div>
							<div class="tl-sub">{{ detailData.level1_admin_name || '—' }}</div>
						</el-timeline-item>
						<el-timeline-item v-if="detailData.level2_time || detailData.level2_result"
							:timestamp="formatTs(detailData.level2_time)" placement="top"
							:type="timelineType(detailData.level2_result)">
							<div class="tl-title">二级审批{{ approveResultSuffix(detailData.level2_result) }}</div>
							<div class="tl-sub">{{ detailData.level2_admin_name || '—' }}</div>
						</el-timeline-item>
						<el-timeline-item v-if="detailData.status === 3 && detailData.reject_remark"
							:timestamp="formatTs(rejectTs(detailData))" placement="top" type="danger">
							<div class="tl-title">驳回说明</div>
							<div class="tl-reject">
								<span class="tl-reject-level">{{ rejectLevelLabel(detailData.reject_level) }}</span>
								{{ detailData.reject_remark }}
							</div>
						</el-timeline-item>
					</el-timeline>
				</template>
			</div>
			<div slot="footer">
				<el-button type="primary" @click="detailVisible = false">关 闭</el-button>
			</div>
		</el-dialog>

		<!-- 驳回后重新编辑 -->
		<el-dialog title="编辑调整申请" :visible.sync="editVisible" width="560px" @closed="editClosed">
			<el-form ref="editForm" :model="editForm" :rules="editRules" label-width="110px">
				<el-form-item label="用户">
					<span>{{ editForm.nickname }} / {{ editForm.phone }}</span>
				</el-form-item>
				<el-form-item label="调整类型" prop="adjust_type">
					<el-radio-group v-model="editForm.adjust_type">
						<el-radio :label="1">增加余额</el-radio>
						<el-radio :label="2">减少余额</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="调整金额" prop="money">
					<el-input-number v-model="editForm.money" :min="0.01" :precision="2" :step="1" style="width: 220px;" />
				</el-form-item>
				<el-form-item label="调整原因" prop="reason">
					<el-select v-model="editForm.reason" placeholder="请选择" style="width: 100%;">
						<el-option label="线下充值" value="offline_recharge" />
						<el-option label="活动奖励" value="activity_reward" />
						<el-option label="客诉补偿" value="customer_compensation" />
						<el-option label="操作失误扣回" value="operation_error" />
						<el-option label="其他" value="other" />
					</el-select>
				</el-form-item>
				<el-form-item v-if="editForm.reason === 'other'" label="原因说明" prop="reason_text">
					<el-input v-model="editForm.reason_text" type="textarea" :rows="2" maxlength="500" show-word-limit />
				</el-form-item>
				<el-form-item label="备注" prop="remark">
					<el-input v-model="editForm.remark" type="textarea" :rows="2" maxlength="500" show-word-limit />
				</el-form-item>
				<el-form-item label="凭证" prop="attachment">
					<FileList v-model="editForm.attachment" :item-width="80" :item-height="80" :limit="6" type="image" />
				</el-form-item>
			</el-form>
			<div slot="footer">
				<el-button @click="editVisible = false">取消</el-button>
				<el-button type="primary" :loading="editLoading" @click="submitEdit">保存并重新提交</el-button>
			</div>
		</el-dialog>

		<!-- 审批 -->
		<el-dialog :title="approveTitle" :visible.sync="approveVisible" width="480px" @closed="approveClosed">
			<el-form ref="approveForm" :model="approveForm" label-width="100px">
				<el-form-item label="审批结果" required>
					<el-radio-group v-model="approveForm.result">
						<el-radio :label="1">通过</el-radio>
						<el-radio :label="2">驳回</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item v-if="approveForm.result === 2" label="驳回原因" required>
					<el-input v-model="approveForm.reject_remark" type="textarea" :rows="3" maxlength="500" show-word-limit />
				</el-form-item>
			</el-form>
			<div slot="footer">
				<el-button @click="approveVisible = false">取消</el-button>
				<el-button type="primary" :loading="approveLoading" @click="submitApprove">确定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		mapGetters
	} from 'vuex'
	import Pagination from '@/components/Pagination'
	import FileList from '@/components/attachment/FileList'
	import {
		listMoneyAdjust,
		detailMoneyAdjust,
		updateRejectedMoneyAdjust,
		deleteRejectedMoneyAdjust,
		level1Approve,
		level2Approve
	} from '@/api/user/userMoneyAdjust'
	import {
		parseTime
	} from '@/utils'

	export default {
		name: 'MoneyAdjustList',
		components: {
			Pagination,
			FileList
		},
		data() {
			const baseUrl = process.env.VUE_APP_BASE_API
			const checkReasonText = (rule, value, callback) => {
				if (this.editForm.reason === 'other' && !String(value || '').trim()) {
					callback(new Error('请填写原因说明'))
				} else {
					callback()
				}
			}
			return {
				base_url: baseUrl,
				list: [],
				total: 0,
				listLoading: false,
				listQuery: {
					page: 1,
					limit: 15,
					order: 'desc',
					sort: 'a.id',
					nickname: '',
					phone: '',
					status: null
				},
				editVisible: false,
				editLoading: false,
				editForm: {
					id: null,
					nickname: '',
					phone: '',
					adjust_type: 1,
					money: null,
					reason: '',
					reason_text: '',
					remark: '',
					attachment: ''
				},
				editRules: {
					adjust_type: [{
						required: true,
						message: '请选择',
						trigger: 'change'
					}],
					money: [{
						required: true,
						message: '请输入金额',
						trigger: 'blur'
					}],
					reason: [{
						required: true,
						message: '请选择原因',
						trigger: 'change'
					}],
					reason_text: [{
						validator: checkReasonText,
						trigger: 'blur'
					}]
				},
				approveVisible: false,
				approveLoading: false,
				approveRow: null,
				approveForm: {
					result: 1,
					reject_remark: ''
				},
				detailVisible: false,
				detailLoading: false,
				detailData: null
			}
		},
		computed: {
			...mapGetters(['current_user']),
			approveTitle() {
				if (!this.approveRow || !this.current_user) return '审批'
				const aid = Number(this.current_user.id)
				const row = this.approveRow
				if (row.status === 2) return '二级审批'
				if (row.status === 1) {
					const l1 = Number(row.level1_admin_id) === aid && Number(row.level1_result) !== 1
					const l2 = Number(row.level2_admin_id) === aid && Number(row.level2_result) !== 1
					if (l1 && !l2) return '一级审批'
					if (l2 && !l1) return '二级审批'
					if (l1 && l2) return '审批'
				}
				return '审批'
			},
			detailAvatarSrc() {
				if (!this.detailData || !this.detailData.avatar) return ''
				return this.detailData.avatar
			},
			attachmentUrls() {
				if (!this.detailData || !this.detailData.attachment) return []
				return this.detailData.attachment.split(',').map(s => this.resolveFileUrl(s.trim())).filter(Boolean)
			}
		},
		created() {
			this.loadData()
		},
		methods: {
			indexMethod(index) {
				return index + 1 + (this.listQuery.page - 1) * this.listQuery.limit
			},
			statusLabel(s) {
				const m = {
					1: '待审批',
					2: '待审批',
					3: '已驳回',
					4: '已完成'
				}
				return m[s] || '—'
			},
			reasonLabel(r) {
				const m = {
					offline_recharge: '线下充值',
					activity_reward: '活动奖励',
					customer_compensation: '客诉补偿',
					operation_error: '操作失误扣回',
					other: '其他'
				}
				return m[r] || r || '—'
			},
			canApprove(row) {
				const aid = this.current_user && this.current_user.id != null ? Number(this.current_user.id) : -1
				if (row.status === 3 || row.status === 4) return false
				if (row.status === 2) {
					return Number(row.level2_admin_id) === aid
				}
				if (row.status === 1) {
					const l1done = Number(row.level1_result) === 1
					const l2done = Number(row.level2_result) === 1
					if (!l1done && Number(row.level1_admin_id) === aid) return true
					if (!l2done && Number(row.level2_admin_id) === aid) return true
				}
				return false
			},
			openDetail(row) {
				this.detailVisible = true
				this.detailData = null
				this.detailLoading = true
				detailMoneyAdjust({
						id: row.id
					})
					.then(res => {
						this.detailData = (res && res.data) ? res.data : null
					})
					.finally(() => {
						this.detailLoading = false
					})
			},
			detailClosed() {
				this.detailData = null
			},
			resolveFileUrl(u) {
				if (!u) return ''
				const s = String(u).trim()
				if (/^https?:\/\//i.test(s)) return s
				const base = (this.base_url || '').replace(/\/?$/, '')
				return base + (s.startsWith('/') ? s : '/' + s)
			},
			formatTs(ts) {
				if (!ts) return '—'
				return parseTime(ts) || '—'
			},
			formatMoney(m) {
				if (m == null || m === '') return '—'
				const n = Number(m)
				return Number.isFinite(n) ? n.toFixed(2) : '—'
			},
			statusTagType(s) {
				const m = {
					1: 'warning',
					2: 'warning',
					3: 'danger',
					4: 'success'
				}
				return m[s] || 'info'
			},
			approveResultSuffix(r) {
				if (r === 1) return ' · 通过'
				if (r === 2) return ' · 驳回'
				return ''
			},
			timelineType(r) {
				if (r === 1) return 'success'
				if (r === 2) return 'danger'
				return 'primary'
			},
			rejectLevelLabel(lvl) {
				if (lvl === 1) return '【一级驳回】'
				if (lvl === 2) return '【二级驳回】'
				return ''
			},
			rejectTs(d) {
				if (!d) return 0
				if (d.reject_level === 1 && d.level1_time) return d.level1_time
				if (d.reject_level === 2 && d.level2_time) return d.level2_time
				return d.update_time
			},
			loadData() {
				this.listLoading = true
				listMoneyAdjust(this.listQuery)
					.then(res => {
						this.list = (res.data && res.data.items) ? res.data.items : []
						this.total = (res.data && res.data.total) ? res.data.total : 0
					})
					.finally(() => {
						this.listLoading = false
					})
			},
			SearchData() {
				this.listQuery.page = 1
				this.loadData()
			},
			resetQuery() {
				this.listQuery.nickname = ''
				this.listQuery.phone = ''
				this.listQuery.status = null
				this.listQuery.page = 1
				this.loadData()
			},
			openEdit(row) {
				this.editForm = {
					id: row.id,
					nickname: row.nickname || '',
					phone: row.phone || '',
					adjust_type: Number(row.adjust_type) || 1,
					money: row.money != null ? Number(row.money) : null,
					reason: row.reason || '',
					reason_text: row.reason_text || '',
					remark: row.remark || '',
					attachment: row.attachment || ''
				}
				this.editVisible = true
			},
			editClosed() {
				this.$refs.editForm && this.$refs.editForm.clearValidate()
			},
			submitEdit() {
				this.$refs.editForm.validate(valid => {
					if (!valid) return
					this.editLoading = true
					const {
						id,
						adjust_type,
						money,
						reason,
						reason_text,
						remark,
						attachment
					} = this.editForm
					updateRejectedMoneyAdjust({
							id,
							adjust_type,
							money,
							reason,
							reason_text,
							remark,
							attachment
						})
						.then(() => {
							this.$message.success('已重新提交，状态：待审批')
							this.editVisible = false
							this.loadData()
						})
						.finally(() => {
							this.editLoading = false
						})
				})
			},
			handleDelete(row) {
				this.$confirm('确定删除该条已驳回记录？', '提示', {
						type: 'warning'
					})
					.then(() => deleteRejectedMoneyAdjust({
						id: row.id
					}))
					.then(() => {
						this.$message.success('已删除')
						this.loadData()
					})
					.catch(() => {})
			},
			openApprove(row) {
				this.approveRow = row
				this.approveForm = {
					result: 1,
					reject_remark: ''
				}
				this.approveVisible = true
			},
			approveClosed() {
				this.approveRow = null
			},
			submitApprove() {
				const {
					result,
					reject_remark
				} = this.approveForm
				if (result === 2 && !String(reject_remark || '').trim()) {
					this.$message.warning('驳回时请填写驳回原因')
					return
				}
				const row = this.approveRow
				if (!row) return
				const payload = {
					id: row.id,
					result,
					reject_remark
				}
				this.approveLoading = true
				const aid = this.current_user && this.current_user.id != null ? Number(this.current_user.id) : -1
				let req
				if (row.status === 2) {
					req = level2Approve(payload)
				} else if (row.status === 1) {
					const asL1 = Number(row.level1_admin_id) === aid && Number(row.level1_result) !== 1
					const asL2 = Number(row.level2_admin_id) === aid && Number(row.level2_result) !== 1
					if (asL1 && !asL2) req = level1Approve(payload)
					else if (asL2 && !asL1) req = level2Approve(payload)
					else if (asL1 && asL2) req = level1Approve(payload)
				}
				if (!req) {
					this.approveLoading = false
					this.$message.warning('无法识别审批角色，请关闭后重试')
					return
				}
				req
					.then(() => {
						this.$message.success('操作成功')
						this.approveVisible = false
						this.loadData()
					})
					.finally(() => {
						this.approveLoading = false
					})
			}
		}
	}
</script>

<style scoped>
	.op-rows {
		display: flex;
		flex-wrap: wrap;
		gap: 6px;
		justify-content: center;
	}

	.detail-body {
		min-height: 100px;
	}

	.detail-user-card {
		display: flex;
		align-items: center;
		gap: 16px;
		padding: 18px 20px;
		margin-bottom: 8px;
		border-radius: 10px;
		background: linear-gradient(125deg, #f4f9ff 0%, #f0faf3 55%, #faf8f4 100%);
		border: 1px solid #ebeef5;
		box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
	}

	.detail-user-meta {
		flex: 1;
		min-width: 0;
	}

	.detail-user-name {
		font-size: 17px;
		font-weight: 600;
		color: #303133;
		line-height: 1.4;
	}

	.detail-user-sub {
		margin-top: 4px;
		font-size: 13px;
		color: #909399;
	}

	.detail-status-pill {
		flex-shrink: 0;
	}

	.detail-section-title {
		margin: 18px 0 10px;
		padding-left: 10px;
		font-size: 14px;
		font-weight: 600;
		color: #606266;
		border-left: 3px solid #409eff;
		line-height: 1.2;
	}

	.detail-desc {
		margin-bottom: 4px;
	}

	.detail-money {
		font-size: 16px;
		font-weight: 600;
		color: #303133;
		font-variant-numeric: tabular-nums;
	}

	.detail-reason-extra {
		color: #909399;
		font-size: 13px;
	}

	.detail-attachments {
		display: flex;
		flex-wrap: wrap;
		gap: 8px;
	}

	.detail-att-img {
		width: 88px;
		height: 88px;
		border-radius: 6px;
		overflow: hidden;
		border: 1px solid #ebeef5;
	}

	.detail-timeline {
		margin-top: 4px;
		padding-left: 2px;
	}

	.tl-title {
		font-weight: 600;
		color: #303133;
		margin-bottom: 4px;
	}

	.tl-sub {
		font-size: 13px;
		color: #909399;
	}

	.tl-reject {
		font-size: 13px;
		color: #606266;
		line-height: 1.6;
	}

	.tl-reject-level {
		display: inline-block;
		margin-right: 6px;
		color: #f56c6c;
		font-weight: 600;
	}
</style>

<style>
	.money-adjust-detail-dialog .el-dialog__body {
		padding: 12px 20px 8px;
		max-height: calc(100vh - 320px);
		overflow-y: auto;
	}
</style>